<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 6,
      height: 11,
      color: 'currentColor',
      viewBoxValue: `0 0 6 11`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M5 10L1 5.5L5 1"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
